import { createReducer } from '@reduxjs/toolkit'
import flow from 'lodash/fp/flow'
import set from 'lodash/fp/set'

import {
    fetchCapabilitiesSuccess,
    fetchTasksSuccess,
    fetchAutomationProfilesSuccess,
    fetchAutomationProfilesFailure,
} from 'actions/ui/campaignPage/automation'
import { defaultPage } from 'reducers/ui/defaults'
import {
    AutomationCapability,
    AutomationProfile,
    AutomationTask,
    DefaultPageState,
} from 'types'

interface AutomationPageState extends DefaultPageState {
    loading: boolean
    saving: boolean
    capabilities: AutomationCapability[]
    tasks: AutomationTask[]
    automationProfiles: {
        error: string | null
        automationProfiles: AutomationProfile[]
    }
    newAutomationProfile: {
        loading: boolean
        error: string | null
    }
}

const defaultState: AutomationPageState = {
    ...defaultPage,
    loading: false,
    saving: false,
    capabilities: [], // Automation capabilities
    tasks: [], // Automation tasks
    automationProfiles: {
        error: null,
        automationProfiles: [],
    },
    newAutomationProfile: {
        loading: false,
        error: null,
    },
}

export default createReducer(defaultState, (builder) => {
    builder
        .addCase(fetchCapabilitiesSuccess, (state, action) => {
            const { results } = action.payload

            return set('capabilities', results)(state)
        })
        .addCase(fetchTasksSuccess, (state, action) => {
            const { results } = action.payload

            return flow(set('tasks', results), set('saving', false))(state)
        })
        .addCase(fetchAutomationProfilesSuccess, (state, action) => {
            const { results } = action.payload

            return flow(
                set(['automationProfiles', 'automationProfiles'], results),
                set(['automationProfiles', 'error'], null)
            )(state)
        })
        .addCase(fetchAutomationProfilesFailure, (state, action) => {
            const error = action.payload

            return set(['automationProfiles', 'error'], error)(state)
        })
})
